import Routine, { RUN } from "+/Engine/Routine";
import DataTypes from "+/Engine/Helpers/DataTypes";
import resolveActionParams from "+/Engine/Helpers/resolveActionParams";

export default class Foreach extends Routine {
  assertValidParams(params) {
    DataTypes.assertObjectKeyExistsOfType("itemEntityType", params, DataTypes.assertString);
    DataTypes.assertObjectKeyExistsOfType("items", params, DataTypes.assertArray);
    DataTypes.assertObjectKeyExistsOfType("paramsDef", params, DataTypes.assertObject);
    DataTypes.assertObjectKeyExistsOfType("eventToRunOnEachItem", params, DataTypes.assertString);
    this.app.assertArrayOfEntitiesHavingValidType(params.items, params.itemEntityType);
  }

  [RUN](params) {
    const { items, paramsDef, eventToRunOnEachItem } = params;

    // paramsDef entries arrive as a mix of pre-resolved values (from the outer Routine
    // resolving "constant" / "params" sources ahead of ForEach execution) and still-deferred
    // source defs for "currentEntity" / "currentEntityField" — those can only be resolved
    // per item. resolveActionParams accepts both shapes: bare values pass through, source
    // defs get resolved against the outer params + entity. `source: currentUser` in the
    // sub-event's paramsDef is resolved from the active session inside resolveActionParams —
    // we deliberately do NOT merge a contexts map in here because sub-events (like outer
    // events) run on event params alone.
    return items.map(item => {
      const entity = this.app.getEntity(params.itemEntityType, item);
      // We use triggerEventWithoutSendingToServer() here, not triggerEvent(). This routine runs
      // inside an already-queued transaction; firing sub-events via triggerEvent() would queue each
      // iteration as a separate transaction and send them to the server independently, which is
      // incorrect. The parent transaction captures the full operation for the server.
      const subEventParams = resolveActionParams(paramsDef, params, entity);
      return this.app.triggerEventWithoutSendingToServer(eventToRunOnEachItem, subEventParams);
    });
  }
}
Routine.register("ForEach", Foreach);
